export default __webpack_public_path__ + "static/subset-UniNeueLight-Italic-573553d45a3e2994889fe0736efb284a.woff2";